import { inject, injectable } from "inversify";
import { GuidSelectModel, ICPLJobTypesClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IJobTypesService {
  getSelectModels(): Promise<GuidSelectModel[]>;
}

@injectable()
export class JobTypesService implements IJobTypesService {
  @inject(SERVICE_TYPES.CPLJobTypesClient) cplJobTypesClient!: ICPLJobTypesClient;

  async getSelectModels(): Promise<GuidSelectModel[]> {
    return this.cplJobTypesClient.getSelectModels();
  }
}
